import * as React from 'react';

import { renderEmpty } from '../../common/Render';
import SimplePieChart from '../../common/Chart/SimplePieChart';
import translate from '../../../../locale/translate';

import { IReportSettings, MAV } from '../../../../interfaces';

import ISettings from './ISettings';
import IWidgetProps from './IWidgetProps';

interface IEventsById {
    nodeId?: MAV.IEvent[];
}

interface IProps extends IWidgetProps {
    settings: ISettings;
}

export default class Widget extends React.Component<IProps, {}> {
    static propTypes = {
        systems: React.PropTypes.array.isRequired,
        settings: React.PropTypes.object.isRequired,
        reportSettings: React.PropTypes.object.isRequired,
    };

    renderVirusInformation(information: { Count: number, Checked: number }) {
        if (!information) {
            return translate.gettext('No MAV installed');
        }

        return information.Count;
    }

    renderSystem(system: MAV.ISystem) {
        return (
            <tr key={system.id}>
                <td>{system.name}</td>
                <td className="text-right">{this.renderVirusInformation(system.virusInformation)}</td>
            </tr>
        );
    }

    renderSummaryTable(systems: MAV.ISystem[], settings: ISettings, reportSettings: IReportSettings) {
        return (
            <div className="space-xl" key="summary">
                <table className="table">
                    <thead>
                        <tr>
                            <th className="col-xs-6">{translate.gettext('Name')}</th>
                            <th className="col-xs-6 text-right">{translate.gettext('MAV thread count')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {systems.map(this.renderSystem.bind(this))}
                    </tbody>
                </table >
            </div >
        );
    }

    renderChart({ has, hasNo }) {
        const data = [
            { x: translate.gettext('Without MAV'), y: hasNo },
            { x: translate.gettext('With MAV'), y: has },
        ];

        return (
            <div key="chart" className="text-center">
                <SimplePieChart data={data} />
            </div>
        );
    }

    renderData(systems: MAV.ISystem[], settings: ISettings, reportSettings: IReportSettings) {
        systems = systems.sort((a: MAV.ISystem, b: MAV.ISystem) => {
            if (!a.virusInformation) {
                return 1;
            }

            if (a.virusInformation && b.virusInformation) {
                if (a.virusInformation.Count > b.virusInformation.Count) {
                    return -1;
                }

                if (a.virusInformation.Count < b.virusInformation.Count) {
                    return 1;
                }
            }

            return 0;
        });

        const children = [];

        if(settings.displayChart) {
            children.push(this.renderChart(this.getChartData(this.props.systems)));
        }

        if(settings.displayTable) {
            children.push(this.renderSummaryTable(systems, settings, reportSettings));
        }

        return children;
    }

    filterSystems(systems: MAV.ISystem[], events: IEventsById, settings: ISettings): MAV.ISystem[] {
        if (!settings.displaySystemsWithoutEvents || !settings.displaySystemsWithoutMav) {
            return systems.filter((system: MAV.ISystem) => {
                const systemEvents = events[system.id] || [];

                if (!system.virusInformation && settings.displaySystemsWithoutMav) {
                    return true;
                } else if (!system.virusInformation) {
                    return false;
                }

                if (!systemEvents.length && settings.displaySystemsWithoutEvents) {
                    return true;
                } else if (!systemEvents.length) {
                    return false;
                }

                return true;
            });
        }

        return systems;
    }

    getChartData(systems: MAV.ISystem[]) {
        return systems.reduce((systemCount, system: MAV.ISystem) => {
            if (system.virusInformation) {
                systemCount.has++;
            } else {
                systemCount.hasNo++;
            }

            return systemCount;
        }, {
            hasNo: 0,
            has: 0,
        });
    }

    render() {
        let { systems } = this.props;
        const { events, settings, reportSettings } = this.props;

        systems = this.filterSystems(systems, events, settings);

        let renderedData;
        if (systems && systems.length) {
            renderedData = this.renderData(systems, settings, reportSettings);
        } else {
            renderedData = renderEmpty();
        }

        return (
            <div>
                {renderedData}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widget/mav/listSystems/Widget.tsx